import { render, staticRenderFns } from "./CourseTable.vue?vue&type=template&id=fcd8b400&scoped=true"
import script from "./CourseTable.vue?vue&type=script&lang=js"
export * from "./CourseTable.vue?vue&type=script&lang=js"
import style0 from "./CourseTable.vue?vue&type=style&index=0&id=fcd8b400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd8b400",
  null
  
)

export default component.exports